import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { cloneDeep } from 'lodash';
import dropdownIcon from 'assets/images/icons/dropdown-arrow-white.svg';
import ConfirmationModal from 'components/common-components/ConfirmationModal';
import MultiLevelSelect from 'components/form-components/MultiLevelSelect';
import { CallAPI } from 'actions/General';
import { createUpdateRecordStructure } from './utils';

const DashboardSetupActions = ({
  ids,
  selectedRows,
  topicList,
  formSets,
  selectedTab,
  updateApiBody,
  setUpdateApiBody,
  // handleManageSets,
  setMetaDataList,
  selectedFormSets,
}) => {
  const { t } = useTranslation();

  const [modifiedOptions, setModifiedOptions] = useState({
    children: [],
  });
  const [setsOptionLookup, setSetsOptionLookup] = useState({});
  const [reImportConfirmationModal, setReImportConfirmationModal] = useState(false);
  const [reImportLoading, setReImportLoading] = useState(false);

  const reImportSQLSubmissionsData = async () => {
    const result = await CallAPI(
      'REIMPORT_FORM_VERTICAL_SQL_SUBMISSIONS',
      { formId: ids[0] },
      null,
      setReImportLoading,
      null,
      null,
    );
    setReImportConfirmationModal(false);
    if (result.status) {
      toast.success('Form vertical export re-import started');
    } else {
      toast.error(result.error);
    }
  };

  useEffect(() => {
    const setsIdLookup = {};

    const allOptions = [
      { value: 're-import', displayValue: 'select_reimport', disabled: ids.length !== 1 },
    ];
    const setOptions = [];

    const topicOptions = [
      //   {
      //   value: 'remove-topic',
      //   displayValue: "remove option"
      // }
    ];
    setsIdLookup['remove-topic'] = {
      setId: '',
      displayValue: '',
      type: 'topic',
    };

    topicList.forEach((topic) => {
      topicOptions.push({
        value: topic._id,
        displayValue: topic.title,
      });
      setsIdLookup[topic._id] = {
        setId: topic._id,
        displayValue: topic.title,
        type: 'topic',
      };
    });

    const topicData = {
      value: 'addToTopic',
      displayValue: 'select_add_to_topic',
      children: topicOptions,
    };

    if (selectedTab === 'forms_structure') {
      allOptions.push(topicData);
    }

    formSets.forEach((set) => {
      const innerOptions = [
        //   {
        //   value: set._id,
        //   displayValue: "remove option"
        // }
      ];
      setsIdLookup[set._id] = {
        setId: set._id,
        displayValue: '',
        type: selectedTab === 'forms_structure' ? 'questionSet' : 'formSet',
      };

      set.options.forEach((o) => {
        innerOptions.push({
          value: o._id,
          displayValue: o.optionValue,
        });
        setsIdLookup[o._id] = {
          setId: set._id,
          displayValue: o.optionValue,
          type: selectedTab === 'forms_structure' ? 'questionSet' : 'formSet',
        };
      });
      if (selectedFormSets.includes(set.sqlColumn)) {
        setOptions.push({
          value: set.sqlColumn,
          displayValue: set.title,
          children: innerOptions,
        });
      }
    });
    const questionData = {
      value: 'addToFormSet',
      displayValue:
        selectedTab === 'forms_structure'
          ? 'select_add_to_questions_set'
          : 'select_add_to_meta_set',
      children: setOptions,
    };
    allOptions.push(questionData);

    const finalOptionsObject = {
      children: allOptions,
    };

    setModifiedOptions(finalOptionsObject);
    setSetsOptionLookup(setsIdLookup);
  }, [formSets, topicList, selectedFormSets, ids]);

  // const  getModifiedAddedColumns = (data, addedColumns)=> {
  //   const modifiedAddedColumns = [...addedColumns];

  //   Object.values(data).forEach(formObject => {
  //     Object.keys(formObject).forEach(key => {
  //       if (key !== "topics" && !modifiedAddedColumns.includes(key)) {
  //         modifiedAddedColumns.push(key);
  //       }
  //     });
  //   });

  //   return modifiedAddedColumns;
  // }

  const handleActionClick = (name, value, displayValue, path) => {
    if (value[0] === 're-import') {
      setReImportConfirmationModal(true);
    } else {
      let updatedMetaDataApiBody = { ...updateApiBody.modifiedData };
      selectedRows.forEach((row) => {
        const form_id = row.form_id;
        const sql_column =
          setsOptionLookup[value[0]].type === 'topic'
            ? 'topics'
            : path.length > 0
            ? path[path.length - 1]
            : '';
        const field_id = selectedTab === 'forms_structure' ? row._id : null;
        const sql_type = setsOptionLookup[value[0]].type;
        const setId = setsOptionLookup[value[0]].setId;
        const selectedId =
          (setsOptionLookup[value[0]].type === 'questionSet' &&
            value[0] === setsOptionLookup[value[0]].setId) ||
          value[0] === 'remove-topic'
            ? ''
            : value[0];
        const selectedValue = setsOptionLookup[value[0]].displayValue;

        updatedMetaDataApiBody = createUpdateRecordStructure(
          updatedMetaDataApiBody,
          form_id,
          sql_column,
          field_id,
          sql_type,
          setId,
          selectedId,
          selectedValue,
        );
        setMetaDataList((prevState) =>
          prevState.map((singleRecord) => {
            if (
              (selectedTab === 'form_meta_and_sql' && singleRecord.formId === form_id) ||
              (selectedTab === 'forms_structure' && field_id === singleRecord.element_global_id)
            ) {
              if (singleRecord[sql_column]) {
                singleRecord[sql_column] = selectedValue;
              } else singleRecord = { ...singleRecord, [sql_column]: selectedValue };
            }
            return singleRecord;
          }),
        );
      });
      // const modifiedAddedColumns = getModifiedAddedColumns(updatedMetaDataApiBody, updateApiBody.addedSetsList);
      const finalObject = {
        ...updateApiBody,
        modifiedData: cloneDeep(updatedMetaDataApiBody),
        // addedSetsList: modifiedAddedColumns,
      };

      setUpdateApiBody(finalObject);
      // handleManageSets(modifiedAddedColumns);
    }
  };

  return (
    <>
      <MultiLevelSelect
        options={modifiedOptions}
        value={[]}
        name='actions'
        disabled={ids.length === 0 || modifiedOptions.children.length === 0}
        handleChange={(name, value, displayValue, path) => {
          console.log({ name, value, displayValue, path });
          handleActionClick(name, value, displayValue, path);
        }}
        classes='theme-font-jakartaSans-regular'
        toggleClasses='px-3 py-2 d-flex gap-2 justify-content-between align-items-center rounded-sm cursor-pointer border-grey-1-h-1 user-select-none theme-button-green-1'
        toggleComponent={
          <>
            <label className='cursor-pointer theme-text-white-1'>{t('button_action')}</label>
            <img className='' src={dropdownIcon} />
          </>
        }
      />
      <ConfirmationModal
        show={reImportConfirmationModal}
        title={t('alert_common_title')}
        message={t('alert_export_setting_reimport_message')}
        actionList={[
          {
            color: 'black-1',
            text: t('button_cancel'),
            onClick: () => setReImportConfirmationModal(false),
          },
          {
            color: 'blue-1',
            text: t('button_reimport'),
            onClick: () => {
              reImportSQLSubmissionsData();
            },
            loading: reImportLoading,
          },
        ]}
      />
    </>
  );
};

DashboardSetupActions.propTypes = {
  ids: PropTypes.array.isRequired,
  selectedRows: PropTypes.array.isRequired,
  topicList: PropTypes.array.isRequired,
  formSets: PropTypes.array.isRequired,
  selectedTab: PropTypes.string.isRequired,
  updateApiBody: PropTypes.object.isRequired,
  setUpdateApiBody: PropTypes.func.isRequired,
  // handleManageSets: PropTypes.func.isRequired,
  setMetaDataList: PropTypes.func.isRequired,
  selectedFormSets: PropTypes.array.isRequired,
};

export default DashboardSetupActions;
